import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { AnalyticsService, AuthenticationService, DataService, LoansService, StorageService } from 'src/app/_services';

@Component({
  selector: 'app-new-record',
  templateUrl: './new-record.component.html',
  styleUrls: ['./new-record.component.css']
})
export class NewRecordComponent implements OnInit {

  @Input() data = null;
  @Input() newColumn = [];
  @Output() close = new EventEmitter();
  @Output() createNewRow = new EventEmitter();
  currentUser: any;

  public updatingData = {}
  updatingArray = []

  newRowForm: any
  
  constructor(
    public loansService: LoansService,
    public analyticsService: AnalyticsService,
    public storageService: StorageService,
    private dataService: DataService,
    public authService: AuthenticationService,
    private router: Router,
    private fb: FormBuilder,
  ) { }

  ngOnInit() {
    this.newRowForm = this.fb.group(this.mapindArray())
  }

  mapindArray() {
    let objectDAta = {}
    console.log(this.newColumn);
    for (let index = 0; index < this.newColumn.length; index++) {
      objectDAta[this.newColumn[index]] = [this.data[this.newColumn[index]]]
    }
    return objectDAta
  }

  async submitForm() {
    this.createNewRow.emit(this.newRowForm.value)
  }

  closeView() {
    this.close.emit()
  }
  
}
